import React from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";

// @material-ui/icons
import Chat from "@material-ui/icons/Chat";

import CastForEducationIcon from '@material-ui/icons/CastForEducation';
import CardMembership from '@material-ui/icons/CardMembership';
import SportsEsportsRounded from '@material-ui/icons/SportsEsportsRounded';
import MonetizationOnRounded from '@material-ui/icons/MonetizationOnRounded';
// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import InfoArea from "components/InfoArea/InfoArea.js";

import styles from "assets/jss/material-kit-react/views/landingPageSections/productStyle.js";
import { Box, Grid } from "@material-ui/core";

const useStyles = makeStyles(styles);

export default function ProductSection() {
  const classes = useStyles();
  return (
    <div className={classes.section}>
      <GridContainer justify="center" >
        <GridItem xs={10} sm={10} md={8}>
          <h2 className={classes.title}>کیفیت آموزشی، اساتید مجرب، مدرک معتبر</h2>
<br/>
          <h5 className={classes.description}>
          کمپ آموزشی شریف به منظور ارتقاء و توسعه نیروی انسانی ماهر دوره‌های تخصصی <strong>سازمانی</strong> و <strong>فردی</strong> برگزار می‌کند. دوره‌های <strong>مقدماتی</strong> تا <strong>پیشرفته</strong> با هدف افزایش تخصص و مهارت نیروهای سازمان یا آماده سازی افراد برای بازارکار به صورت <strong>حضوری</strong> و <strong>غیرحضوری</strong> توسط اساتید مجرب و متعهد برگزار می شود.
          در پایان هر دوره یا مجموعه دوره، <strong>گواهینامه معتبر</strong> قابل استعلام و نتایج ارزیابی با جزییات ارائه می‌گردد.
          </h5>
        </GridItem>
      </GridContainer>
    </div>
  );
}
